import {css} from 'lit';

export default css`

.primary-nav {
  min-height: 3.25rem;
  background-color: #fff;
}
@media (min-width: 992px) {
  .primary-nav {
    background-color: transparent;
    font-size: 0.85rem;
  }
  .primary-nav ul ul {
    display: none;
  }
  .primary-nav li {
    float: left;
  }
  .primary-nav li:hover ul {
    background-color: #fffbed;
  }
  .primary-nav li li {
    float: none;
  }
  .primary-nav li:hover > .primary-nav__top-link a, .primary-nav li:focus-within > .primary-nav__top-link a, .primary-nav li:hover > .primary-nav__top-link .primary-nav__nolink {
    color: #022851;
  }
  .primary-nav .submenu-toggle {
    display: none;
  }
}
.primary-nav a, .primary-nav__nolink {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 0.15rem solid #fff;
  background-color: #dbeaf7;
  color: #022851;
  font-weight: 700;
  line-height: 1.5rem;
  text-decoration: none;
}
@media (min-width: 992px) {
  .primary-nav a, .primary-nav__nolink {
    margin-left: 1rem;
    padding: 0;
    border-bottom: 0;
    background-color: transparent;
    font-weight: 700;
    line-height: 3.25rem;
  }
  .primary-nav a:before, .primary-nav__nolink:before {
    width: 1rem;
    height: 3.25rem;
    margin-right: 0.5rem;
    margin-left: -1rem;
    background-color: transparent;
    clip-path: polygon(93% 0, 110% 0, 110% 102%, 0% 102%);
    content: "";
  }
  .primary-nav a:focus:before, .primary-nav a:hover:before, .primary-nav__nolink:focus:before, .primary-nav__nolink:hover:before {
    background-color: #ffbf00;
  }
  .primary-nav a:after, .primary-nav__nolink:after {
    z-index: 1;
    width: 1rem;
    height: 3.25rem;
    margin-right: -1rem;
    margin-left: 0.5rem;
    background-color: transparent;
    clip-path: polygon(-2px -2px, 100% -2px, 7% 102%, -2px 100%);
    content: "";
  }
  .primary-nav a:focus:after, .primary-nav a:hover:after, .primary-nav__nolink:focus:after, .primary-nav__nolink:hover:after {
    background-color: #ffbf00;
  }
}
.primary-nav a:hover, .primary-nav__nolink:hover {
  background-color: #ffbf00;
}
.primary-nav a:focus,
.primary-nav a .active, .primary-nav__nolink:focus,
.primary-nav__nolink .active {
  background-color: #ffbf00;
}
.primary-nav__button {
  display: flex;
  width: 100%;
  padding: 0.75rem;
  border: 0;
  border-bottom: 0.15rem solid #fff;
  background-color: #dbeaf7;
  color: #022851;
  font-weight: 700;
  line-height: 1.5rem;
  text-decoration: none;
}
@media (min-width: 992px) {
  .primary-nav__button {
    margin-left: 1rem;
    width: auto;
    padding: 0;
    border-bottom: 0;
    background-color: transparent;
    color: #fff;
    font-weight: 700;
    line-height: 3.25rem;
    white-space: nowrap;
  }
  .primary-nav__button:before {
    width: 1rem;
    height: 3.25rem;
    margin-right: 0.5rem;
    margin-left: -1rem;
    background-color: transparent;
    clip-path: polygon(93% 0, 110% 0, 110% 102%, 0% 102%);
    content: "";
  }
  .primary-nav__button:focus:before, .primary-nav__button:hover:before {
    background-color: #ffbf00;
  }
  .primary-nav__button:after {
    z-index: 1;
    width: 1rem;
    height: 3.25rem;
    margin-right: -1rem;
    margin-left: 0.5rem;
    background-color: transparent;
    clip-path: polygon(-2px -2px, 100% -2px, 7% 102%, -2px 100%);
    content: "";
  }
  .primary-nav__button:focus:after, .primary-nav__button:hover:after {
    background-color: #ffbf00;
  }
}
.primary-nav__button:hover {
  background-color: #ffbf00;
  color: #022851;
}
.primary-nav__button:focus {
  background-color: #ffbf00;
  color: #022851;
}
@media (min-width: 992px) {
  .primary-nav__top-link a, .primary-nav__top-link .primary-nav__nolink {
    color: #fff;
    white-space: nowrap;
  }
  .primary-nav__top-link a:hover, .primary-nav__top-link .primary-nav__nolink:hover {
    color: #022851;
  }
}
.primary-nav li li a, li li .primary-nav__nolink {
  flex-grow: 1;
  border-color: #fff;
  background-color: #fde9ac;
  font-weight: 400;
}
@media (max-width: 991px) {
  .primary-nav li li a, li li .primary-nav__nolink {
    display: flex;
    align-items: center;
  }
  .primary-nav li li a:before, li li .primary-nav__nolink:before {
    margin-right: 0.5rem;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
  .primary-nav li li a:before, li li .primary-nav__nolink:before {
    color: #ffbf00;
    content: '\\f0a9';
    font-size: 1.25em;
  }
  .primary-nav li li a:focus:before, .primary-nav li li a:hover:before, li li .primary-nav__nolink:focus:before, li li .primary-nav__nolink:hover:before {
    color: #022851;
  }
}
@media (min-width: 992px) {
  .primary-nav li li a, li li .primary-nav__nolink {
    margin-left: 0;
    padding: 0.5rem 1rem;
    font-size: 0.9375em;
    line-height: 1.35;
  }
  .primary-nav li li a:focus, li li .primary-nav__nolink:focus {
    background-color: #ffbf00;
  }
  .primary-nav li li a:before, .primary-nav li li a:after, li li .primary-nav__nolink:before, li li .primary-nav__nolink:after {
    display: none;
  }
}
.primary-nav li li li a {
  background-color: #fff9e6;
}
@media (min-width: 992px) {
  .primary-nav--justify > .menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .primary-nav--justify li {
    float: none;
    flex-basis: 0;
    flex-grow: 1;
    width: auto;
  }
  .primary-nav--justify li:last-child .primary-nav__top-link a, .primary-nav--justify li:last-child .primary-nav__top-link .primary-nav__nolink {
    margin-right: 1rem;
  }
  .primary-nav--justify a:after,
  .primary-nav--justify .primary-nav__nolink:after {
    margin-left: auto;
  }
}
@media (min-width: 992px) {
  .primary-nav--mega {
    overflow: hidden;
    max-height: 3.25rem;
    margin-right: -1rem;
    transition: max-height 0.3s;
  }
  .primary-nav--mega.is-hover {
    max-height: 600px;
  }
  .primary-nav--mega a:after,
  .primary-nav--mega .primary-nav__nolink:after {
    margin-left: auto;
  }
  .primary-nav--mega > .menu {
    display: flex;
    flex-wrap: wrap;
  }
  .primary-nav--mega li {
    float: none;
    width: auto;
    min-width: 9em;
  }
  .primary-nav--mega li li a,
  .primary-nav--mega li li .primary-nav__nolink {
    background: none;
  }
  .primary-nav--mega li:hover .primary-nav__top-link a,
  .primary-nav--mega li:hover .primary-nav__top-link .primary-nav__nolink,
  .primary-nav--mega li:focus-within .primary-nav__top-link a,
  .primary-nav--mega li:focus-within .primary-nav__top-link .primary-nav__nolink {
    background-color: #ffdf80;
    color: #022851;
  }
  .primary-nav--mega li:hover .primary-nav__top-link a:before, .primary-nav--mega li:hover .primary-nav__top-link a:after,
  .primary-nav--mega li:hover .primary-nav__top-link .primary-nav__nolink:before,
  .primary-nav--mega li:hover .primary-nav__top-link .primary-nav__nolink:after,
  .primary-nav--mega li:focus-within .primary-nav__top-link a:before,
  .primary-nav--mega li:focus-within .primary-nav__top-link a:after,
  .primary-nav--mega li:focus-within .primary-nav__top-link .primary-nav__nolink:before,
  .primary-nav--mega li:focus-within .primary-nav__top-link .primary-nav__nolink:after {
    background-color: #ffdf80;
  }
  .primary-nav--mega li .primary-nav__top-link a:hover {
    background-color: #ffbf00;
  }
  .primary-nav--mega li .primary-nav__top-link a:hover:before, .primary-nav--mega li .primary-nav__top-link a:hover:after {
    background-color: #ffbf00;
  }
  .primary-nav--mega .primary-nav__top-link {
    background-color: #022851;
  }
}
@media (min-width: 992px) {
  .primary-nav--superfish {
    box-shadow: inset 0 -1px 0 #14447a;
  }
  .primary-nav--superfish li {
    position: relative;
  }
  .primary-nav--superfish ul ul {
    position: absolute;
    z-index: 840;
    top: 100%;
    left: 0;
    display: none;
    min-width: 12em;
    background-color: #fff;
  }
  .primary-nav--superfish ul ul ul {
    top: 0;
    left: 100%;
  }
  .primary-nav--superfish li li a,
  .primary-nav--superfish li li .primary-nav__nolink {
    background-color: #fffbed;
  }
  .primary-nav--superfish li li li a,
  .primary-nav--superfish li li li .primary-nav__nolink {
    background-color: #fffbed;
  }
  .primary-nav--superfish li li li li a,
  .primary-nav--superfish li li li li .primary-nav__nolink {
    background-color: #fff9e6;
  }
  .primary-nav--superfish .primary-nav__submenu-indicator {
    display: flex;
    align-items: center;
    width: 1rem;
    height: auto;
    margin-right: -0.5rem;
    margin-left: auto;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent;
  }
  .primary-nav--superfish .primary-nav__submenu-indicator:after {
    margin-left: 0.5rem;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
  .primary-nav--superfish .primary-nav__submenu-indicator:focus {
    box-shadow: none;
  }
  .primary-nav--superfish .primary-nav__submenu-indicator:after {
    color: #ffbf00;
    content: '\\f054';
    font-size: 0.75em;
  }
  .primary-nav--superfish li li .primary-nav__submenu-indicator:after {
    color: #022851;
  }
  .primary-nav--superfish li li li .primary-nav__submenu-indicator {
    display: none;
  }
  .primary-nav--superfish li:hover > ul,
  .primary-nav--superfish .sf--hover > ul {
    display: block;
  }
  .primary-nav--superfish li:hover > .primary-nav__top-link a,
  .primary-nav--superfish li:hover > .primary-nav__top-link .primary-nav__nolink,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link a,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link .primary-nav__nolink {
    background-color: #ffbf00;
  }
  .primary-nav--superfish li:hover > .primary-nav__top-link a:before, .primary-nav--superfish li:hover > .primary-nav__top-link a:after,
  .primary-nav--superfish li:hover > .primary-nav__top-link .primary-nav__nolink:before,
  .primary-nav--superfish li:hover > .primary-nav__top-link .primary-nav__nolink:after,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link a:before,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link a:after,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link .primary-nav__nolink:before,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link .primary-nav__nolink:after {
    background-color: #ffbf00;
  }
  .primary-nav--superfish li:hover > .primary-nav__top-link a .primary-nav__submenu-indicator:after,
  .primary-nav--superfish li:hover > .primary-nav__top-link .primary-nav__nolink .primary-nav__submenu-indicator:after,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link a .primary-nav__submenu-indicator:after,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link .primary-nav__nolink .primary-nav__submenu-indicator:after {
    color: #022851;
  }
  .primary-nav--superfish li:hover > .primary-nav__top-link a,
  .primary-nav--superfish .sf--hover > .primary-nav__top-link a,
  .primary-nav--superfish li:hover > .primary-nav__top-link .primary-nav__nolink {
    color: #022851;
  }
}
.primary-nav .submenu-toggle:focus {
  box-shadow: inset 0 0 0 3px #ffbf00;
  outline: none;
}

`;